export default "__VITE_ASSET__id6o2wBA__"